module.exports = __webpack_public_path__ + "static/Number 101-b63f163dbcb2b876bbac32979e0727ce.jpg";